/*
 * product-card.js — behaviour for product cards (quick-add, variant switching, price formatting)
 *
 * PERF (TC-0): this code previously lived inline inside snippets/card-product.liquid and was
 * emitted once PER CARD. The homepage renders 91 cards, so the browser downloaded, parsed and
 * compiled ~25 KB x 91 = 2.3 MB of identical JavaScript on every page view, purely to run it once.
 * The `if (window.__pcc...) return;` guards stopped it EXECUTING twice, but not being PARSED 91 times.
 *
 * It now loads once, deferred, from Shopify's CDN with a 1-year cache.
 * Shop currency/locale come from window.__pccConfig, set in snippets/product-card-assets.liquid.
 */
    if (!window.__pccVariantChangeInit) {
      window.__pccVariantChangeInit = true;

      const SHOP_CURRENCY = (window.__pccConfig && window.__pccConfig.currency) || 'INR';
      const SHOP_LOCALE = (window.__pccConfig && window.__pccConfig.locale) || 'en-IN';

      function fmtMoney(cents) {
        if (cents == null || isNaN(cents)) return '';
        try {
          return new Intl.NumberFormat(SHOP_LOCALE, {
            style: 'currency',
            currency: SHOP_CURRENCY,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).format(cents / 100);
        } catch (e) {
          return '₹' + Math.round(cents / 100);
        }
      }

      function resolveVariantImage(variant) {
        if (variant.featured_image) {
          if (typeof variant.featured_image === 'string') return variant.featured_image;
          if (variant.featured_image.src) return variant.featured_image.src;
        }
        if (variant.featured_media) {
          if (variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
            return variant.featured_media.preview_image.src;
          }
          if (variant.featured_media.src) return variant.featured_media.src;
        }
        return null;
      }

      document.addEventListener('change', function (e) {
        let variantId;
        if (e.target.classList.contains('variant-dropdown')) {
          variantId = e.target.value;
        } else if (e.target.classList.contains('variant-radio')) {
          variantId = e.target.value;
        } else {
          return;
        }

        const form = e.target.closest('form');
        const card = e.target.closest('.card-wrapper');
        if (!form || !card) return;

        const idInput = form.querySelector('.js-variant-id');
        if (idInput) idInput.value = variantId;

        const container = form.querySelector('.quick-add-container');
        if (container) container.dataset.variantId = variantId;

        const jsonEl = card.querySelector('.product-json');
        if (!jsonEl) return;

        // PERF: cache parsed JSON on element so we don't re-parse every variant change
        let productData = jsonEl._parsed;
        if (!productData) {
          try {
            productData = JSON.parse(jsonEl.textContent);
            jsonEl._parsed = productData;
          } catch (err) {
            console.error('Bad product JSON', err);
            return;
          }
        }

        const variant = productData.variants.find((v) => String(v.id) === String(variantId));
        if (!variant) return;

        // ─── IMAGE SWAP ───
        let newSrc = resolveVariantImage(variant);
        if (newSrc) {
          if (newSrc.indexOf('//') === 0) newSrc = 'https:' + newSrc;
          const img = card.querySelector('.card__media img');
          if (img && img.src !== newSrc) {
            img.removeAttribute('srcset');
            img.src = newSrc;
          }
        }

// ─── PRICE UPDATE (integer, no decimals) ───
const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;

const priceWrapper = card.querySelector('.price');
if (priceWrapper) {
  priceWrapper.classList.toggle('price--on-sale', onSale);
  priceWrapper.classList.toggle('price--no-compare', !onSale);
}

// Regular price (in .price__regular — shown when NOT on sale)
const regularPrice = card.querySelector('.price__regular .price-item--regular');
if (regularPrice) regularPrice.innerHTML = fmtMoney(variant.price);

// Current/sale price (in .price__sale — shown when on sale)
const salePrice = card.querySelector('.price__sale .price-item--sale');
if (salePrice) salePrice.innerHTML = fmtMoney(variant.price);

// Old struck-through price (in .price__sale > s)
const compareEl = card.querySelector('.price__sale s.price-item--regular');
if (compareEl) {
  compareEl.innerHTML = onSale ? fmtMoney(variant.compare_at_price) : '';
}
// ─── DISCOUNT % UPDATE ───
const discountEl = card.querySelector('.discount-percent');
if (discountEl) {
  if (onSale) {
    const percent = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
    discountEl.textContent = percent + '% OFF';
    discountEl.style.display = 'inline-flex';
    discountEl.dataset.variantId = variant.id;
    discountEl.dataset.price = variant.price;
    discountEl.dataset.comparePrice = variant.compare_at_price;
  } else {
    discountEl.style.display = 'none';
  }
}
        // ─── BUTTON STATE ───
        const btn = form.querySelector('.add-btn');
        if (btn) {
          btn.disabled = !variant.available;
          btn.classList.toggle('disabled', !variant.available);
          const btnText = btn.querySelector('.btn-text');
          if (btnText) btnText.textContent = variant.available ? 'Add to cart' : 'Sold out';
        }

        if (window.syncCardQuantitiesWithCart) window.syncCardQuantitiesWithCart();
      });
    }
  

    (function () {
      if (window.__pccInitialized) return;
      window.__pccInitialized = true;

      // Pre-warm cart connection on first hover/touch over any add button
      let __warmed = false;
      function warmCart() {
        if (__warmed) return;
        __warmed = true;
        fetch('/cart.js', { credentials: 'same-origin' }).catch(() => {});
      }
      document.addEventListener('pointerenter', function (e) {
        if (e.target.closest && e.target.closest('.add-btn')) warmCart();
      }, true);
      document.addEventListener('touchstart', function (e) {
        if (e.target.closest && e.target.closest('.add-btn')) warmCart();
      }, { passive: true, capture: true });

      const cartState = {};
      const pending = {};
      const debounceTimers = {};
      const debounceTargets = {};

      const DEBOUNCE_MS = 220;
      const MIN_LOADING_MS = 1300;

      function getVariantId(container) {
        if (!container) return '';

        const form = container.closest('form');
        const card = container.closest('.card-wrapper');

        const dropdown =
          (form && form.querySelector('select.variant-dropdown')) ||
          (card && card.querySelector('select.variant-dropdown'));

        const checkedRadio =
          (form && form.querySelector('input.variant-radio:checked')) ||
          (card && card.querySelector('input.variant-radio:checked'));

        const hidden =
          form &&
          (form.querySelector('input.js-variant-id') ||
            form.querySelector('input[name="id"]'));

        return String(
          (dropdown && dropdown.value) ||
          (checkedRadio && checkedRadio.value) ||
          (hidden && hidden.value) ||
          container.dataset.variantId ||
          ''
        );
      }

      function setQty(container, qty) {
        if (!container) return;

        const qtyEl = container.querySelector('.qty');
        const addBtn = container.querySelector('.add-btn');
        const qtyWrapper = container.querySelector('.qty-wrapper');

        if (qtyEl) qtyEl.textContent = qty;

        if (qty > 0) {
          addBtn && addBtn.classList.add('hidden');
          qtyWrapper && qtyWrapper.classList.remove('hidden');
        } else {
          addBtn && addBtn.classList.remove('hidden');
          qtyWrapper && qtyWrapper.classList.add('hidden');
        }
      }

      function syncContainerToVariant(container, variantId) {
        if (!container || !variantId) return;
        container.dataset.variantId = variantId;
        setQty(container, cartState[variantId] || 0);
      }

      function setLoading(container, loading, type) {
        if (!container) return;

        type = type || 'add';

        const addBtn = container.querySelector('.add-btn');
        const btnText = addBtn && addBtn.querySelector('.btn-text');
        const qtyBtns = container.querySelectorAll('.qty-btn');

        if (addBtn) {
          addBtn.classList.toggle('is-loading', loading && type === 'add');
          addBtn.disabled = loading;

          if (btnText) {
            if (loading && type === 'add') {
              if (!btnText.dataset.original) {
                btnText.dataset.original = btnText.textContent.trim();
              }
              btnText.textContent = 'Adding...';
            } else if (!loading && btnText.dataset.original) {
              btnText.textContent = btnText.dataset.original;
              delete btnText.dataset.original;
            }
          }
        }

        qtyBtns.forEach((btn) => {
          btn.disabled = loading;
        });
      }

      function bumpQty(container) {
        const el = container && container.querySelector('.qty');
        if (!el) return;

        el.classList.remove('is-bumped');
        void el.offsetWidth;
        el.classList.add('is-bumped');
      }

      // Loading state for the +/- stepper: spinner on the qty number,
      // and disable both qty buttons so taps don't queue while updating.
      function setQtyLoading(container, loading) {
        if (!container) return;
        const wrapper = container.querySelector('.qty-wrapper');
        if (wrapper) wrapper.classList.toggle('qty-loading', loading);
        container.querySelectorAll('.qty-btn').forEach((btn) => {
          btn.disabled = loading;
        });
      }

      function paintHeaderCount(itemCount) {
        document
          .querySelectorAll(
            '.cart-count, .header__cart-count, .cart-count-bubble, .site-header__cart-count'
          )
          .forEach((el) => {
            const n =
              el.querySelector('span[aria-hidden="true"]') ||
              el.querySelector('span:not(.visually-hidden)');

            if (n) n.textContent = itemCount;
            else el.textContent = itemCount;

            if (el.classList.contains('cart-count-bubble')) {
              el.style.display = itemCount > 0 ? '' : 'none';
            }
          });

        document
          .querySelectorAll('.cart-count-bubble span.visually-hidden')
          .forEach((el) => {
            el.textContent = itemCount + ' items';
          });
      }

      function localTotalCount() {
        let n = 0;
        for (const k in cartState) n += cartState[k];
        return n;
      }

      function broadcastCart(cart) {
        document.dispatchEvent(
          new CustomEvent('cart:updated', { detail: { cart }, bubbles: true })
        );
        document.dispatchEvent(
          new CustomEvent('cart:change', { detail: { cart }, bubbles: true })
        );
      }

      function ingestCart(cart) {
        for (const k in cartState) delete cartState[k];

        cart.items.forEach((item) => {
          const v = String(item.variant_id);
 if (!cartState[v]) cartState[v] = item.quantity;
        });

        paintHeaderCount(cart.item_count || 0);
        broadcastCart(cart);
      }

      function applyCartStateToCards() {
        document.querySelectorAll('.quick-add-container').forEach((container) => {
          const variantId = String(container.dataset.variantId || '');
          if (!variantId || pending[variantId]) return;
          setQty(container, cartState[variantId] || 0);
        });
      }

      async function fetchCartAndSync() {
        try {
          const res = await fetch('/cart.js', { credentials: 'same-origin' });
          const cart = await res.json();
          ingestCart(cart);
          applyCartStateToCards();
        } catch (err) {
          console.error('Cart fetch failed', err);
        }
      }

      window.syncCardQuantitiesWithCart = fetchCartAndSync;

      // ─── Variant change ───
      document.addEventListener('change', function (e) {
        const isDropdown = e.target.matches('.variant-dropdown');
        const isRadio = e.target.matches('.variant-radio');

        if (!isDropdown && !isRadio) return;

        const form = e.target.closest('form');
        if (!form) return;

        const container = form.querySelector('.quick-add-container');
        if (!container) return;

        const variantId = String(e.target.value || '');
        if (!variantId) return;

        const hidden =
          form.querySelector('input.js-variant-id') ||
          form.querySelector('input[name="id"]');

        if (hidden) hidden.value = variantId;

        syncContainerToVariant(container, variantId);
      });

      // ─── Debounced qty change ───
      function scheduleChange(variantId, qty, container) {
        debounceTargets[variantId] = qty;

        // FAKE SPINNER — show loading now, clear on a fixed timer (not the network).
        setQtyLoading(container, true);
        if (container.__qtyLoadingTimer) clearTimeout(container.__qtyLoadingTimer);
        container.__qtyLoadingTimer = setTimeout(function () {
          setQtyLoading(container, false);
          container.__qtyLoadingTimer = null;
          setQty(container, cartState[variantId] || 0);
        }, MIN_LOADING_MS);

        if (debounceTimers[variantId]) {
          clearTimeout(debounceTimers[variantId]);
        }

        debounceTimers[variantId] = setTimeout(() => {
          delete debounceTimers[variantId];

          const target = debounceTargets[variantId];
          delete debounceTargets[variantId];

          executeChange(variantId, target, container);
        }, DEBOUNCE_MS);
      }

      async function executeChange(variantId, quantity, container) {
        pending[variantId] = (pending[variantId] || 0) + 1;

        try {
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ id: variantId, quantity: quantity }),
          });

          const cart = await res.json();
          ingestCart(cart);
        } catch (err) {
          console.error('Quantity change failed', err);
          fetchCartAndSync();
        } finally {
          pending[variantId] = Math.max(0, (pending[variantId] || 1) - 1);

          // Don't override the UI while a fake loading timer is still running
          // (e.g. the 1→0 switch is holding the stepper + spinner visible).
          if (!pending[variantId] && container && !container.__qtyLoadingTimer) {
            setQty(container, cartState[variantId] || 0);
          }
        }
      }

      // ─── Click: ADD TO CART ───
      document.addEventListener(
        'click',
        async function (e) {
          const btn = e.target.closest('.add-btn');
          if (!btn) return;
          if (btn.disabled || btn.classList.contains('disabled')) return;

          e.preventDefault();
          e.stopImmediatePropagation();

          const container = btn.closest('.quick-add-container');
          if (!container) return;

          const variantId = getVariantId(container);
          if (!variantId) {
            setLoading(container, false);
            return;
          }

          container.dataset.variantId = variantId;

          const newQty = (cartState[variantId] || 0) + 1;

          // ───────────────────────────────────────────────
          // FAKE SPINNER — show spinner now, DON'T swap to stepper yet
          // ───────────────────────────────────────────────
          setLoading(container, true, 'add');

          // Optimistic header count only (sticky bar waits for the real fetch)
          cartState[variantId] = newQty;
          paintHeaderCount(localTotalCount());

          // Product data (used for the lock + later sticky-bar fill)
          const card = container.closest('.card-wrapper');
          let productData = null;
          if (card) {
            const jsonEl = card.querySelector('.product-json');
            if (jsonEl) {
              try {
                productData = jsonEl._parsed || JSON.parse(jsonEl.textContent);
                jsonEl._parsed = productData;
              } catch (err) {}
            }
          }

          let variantData = null;
          let productImage = null;
          let productTitle = '';
          if (productData) {
            variantData = productData.variants.find(v => String(v.id) === String(variantId));
            productImage = (variantData && variantData.featured_image && variantData.featured_image.src) ||
                           (productData.featured_image) ||
                           (productData.images && productData.images[0]);
            productTitle = productData.title || '';
          }

          // Lock the count so a stale 0 can't hide the bar later.
          // The bar itself stays hidden until the real cart is fetched.
          document.dispatchEvent(new CustomEvent('cart:optimistic-add', {
            detail: {
              variantId: variantId,
              quantity: 1,
              price: variantData ? variantData.price : 0,
              compareAtPrice: variantData ? (variantData.compare_at_price || 0) : 0,
              image: productImage,
              title: productTitle,
              productId: productData ? productData.id : null
            },
            bubbles: true
          }));

          pending[variantId] = (pending[variantId] || 0) + 1;

          // Fixed 150ms spinner — swap to stepper on a timer, NOT on the network.
          setTimeout(function () {
            setQty(container, newQty);
            setLoading(container, false);
          }, MIN_LOADING_MS);

          // Fire the request in the background; reconcile the cart when it lands.
          (function () {
            const fd = new FormData();
            fd.append('id', variantId);
            fd.append('quantity', '1');
            fd.append('properties[_unique]', Date.now().toString());

            fetch('/cart/add.js', {
              method: 'POST',
              body: fd,
              headers: { Accept: 'application/json' },
              credentials: 'same-origin',
            })
            .then(function (res) {
              if (!res.ok) {
                // ROLLBACK on failure
                cartState[variantId] = Math.max(0, newQty - 1);
                paintHeaderCount(localTotalCount());
                setLoading(container, false);
                setQty(container, cartState[variantId] || 0);
                document.dispatchEvent(new CustomEvent('cart:optimistic-rollback', {
                  detail: { variantId: variantId, quantity: 1 },
                  bubbles: true
                }));
                return;
              }
              // Sticky bar appears when the real cart is fetched
              fetchCartAndSync();
            })
            .catch(function (err) {
              cartState[variantId] = Math.max(0, newQty - 1);
              paintHeaderCount(localTotalCount());
              setLoading(container, false);
              setQty(container, cartState[variantId] || 0);
              console.error('Add to cart error', err);
              document.dispatchEvent(new CustomEvent('cart:optimistic-rollback', {
                detail: { variantId: variantId, quantity: 1 },
                bubbles: true
              }));
            })
            .finally(function () {
              pending[variantId] = Math.max(0, (pending[variantId] || 1) - 1);
            });
          })();
        },
        true
      );

      // ─── Click: +/- qty ───
      document.addEventListener(
        'click',
        function (e) {
          const qtyBtn = e.target.closest('.qty-btn');
          if (!qtyBtn) return;
          if (qtyBtn.disabled) return;

          const container = qtyBtn.closest('.quick-add-container');
          if (!container) return;

          const variantId = getVariantId(container);
          if (!variantId) return;

          container.dataset.variantId = variantId;

          const qtyEl = container.querySelector('.qty');
          let qty = parseInt(qtyEl && qtyEl.textContent, 10) || 1;

          if (qtyBtn.classList.contains('plus')) qty++;
          if (qtyBtn.classList.contains('minus')) qty--;

          qty = Math.max(0, qty);

          cartState[variantId] = qty;
          paintHeaderCount(localTotalCount());

          if (qty === 0) {
            // Going to 0 → keep the stepper visible with a fake spinner for
            // MIN_LOADING_MS, THEN swap back to the Add to Cart button.
            if (qtyEl) qtyEl.textContent = 0;
            setQtyLoading(container, true);
            if (container.__qtyLoadingTimer) clearTimeout(container.__qtyLoadingTimer);
            container.__qtyLoadingTimer = setTimeout(function () {
              setQtyLoading(container, false);
              container.__qtyLoadingTimer = null;
              setQty(container, 0); // now reveals the Add to Cart button
            }, MIN_LOADING_MS);
            // Still fire the cart update (debounced) in the background
            debounceTargets[variantId] = 0;
            if (debounceTimers[variantId]) clearTimeout(debounceTimers[variantId]);
            debounceTimers[variantId] = setTimeout(() => {
              delete debounceTimers[variantId];
              const target = debounceTargets[variantId];
              delete debounceTargets[variantId];
              executeChange(variantId, target, container);
            }, DEBOUNCE_MS);
            return;
          }

          setQty(container, qty);
          bumpQty(container);

          scheduleChange(variantId, qty, container);
        },
        true
      );

      // ─── Init ───
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', fetchCartAndSync);
      } else {
        setTimeout(fetchCartAndSync, 0);
      }

      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          fetchCartAndSync();
        }
      });

      // ─── Re-sync when GoKwik (or any external cart) changes quantities ───
      var __resyncTimer = null;
      function externalCartChanged() {
        clearTimeout(__resyncTimer);
        __resyncTimer = setTimeout(fetchCartAndSync, 250);
      }

      [
        'gk:cart:updated', 'gokwik:cart:updated', 'gk_cart_updated',
        'cart:refresh', 'cart:build', 'cart:item:updated', 'ajaxCart:afterCartLoad'
      ].forEach(function (evt) {
        document.addEventListener(evt, externalCartChanged);
        window.addEventListener(evt, externalCartChanged);
      });

      // Fallback 1: when GoKwik drawer/overlay is clicked, re-pull the cart
      document.addEventListener('click', function (e) {
        if (e.target.closest && (
          e.target.closest('[class*="sidecart"]') ||
          e.target.closest('[class*="gokwik"]') ||
          e.target.closest('[class*="overlay"]')
        )) {
          externalCartChanged();
        }
      }, true);

      // Fallback 2: re-sync whenever the page regains focus or pointer returns to a card
      window.addEventListener('focus', externalCartChanged);
      document.addEventListener('pointerenter', function (e) {
        if (e.target.closest && e.target.closest('.quick-add-container')) {
          externalCartChanged();
        }
      }, true);

      // ─── Instant sync: poll cart while GoKwik drawer is open ───
      var __cartPoll = null;
      var __lastCartCount = null;

      var __lastCartSig = null;

      async function pollCartOnce() {
        try {
          const res = await fetch('/cart.js', { credentials: 'same-origin' });
          const cart = await res.json();
          var sig = cart.item_count + '|' + cart.items.map(function (i) {
            return i.variant_id + ':' + i.quantity;
          }).join(',');
          if (__lastCartSig === null) { __lastCartSig = sig; return; }
          if (sig !== __lastCartSig) {
            __lastCartSig = sig;
            ingestCart(cart);
            applyCartStateToCards();
          }
        } catch (e) {}
      }

      function startCartPolling() {
        if (__cartPoll) return;
        __lastCartSig = null;
        __cartPoll = setInterval(pollCartOnce, 250);
      }
      function stopCartPolling() {
        clearInterval(__cartPoll);
        __cartPoll = null;
      }

      new MutationObserver(function () {
        var drawerOpen = document.querySelector(
          '[class*="sidecart"], shadow-dom-container, [class*="gokwik"]'
        );
        if (drawerOpen) startCartPolling();
        else stopCartPolling();
      }).observe(document.body, { childList: true, subtree: true });

      console.log('✅ Card quick-add ready (variant-aware)');
    })();
  

    (function () {
      if (window.__pccStripDecimals) return;
      window.__pccStripDecimals = true;

      function stripDecimalsFromCards() {
        document.querySelectorAll('.card-wrapper .price, .card-wrapper .price-item, .card-wrapper [data-price]').forEach(function (el) {
          const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
          let node;
          while ((node = walker.nextNode())) {
            const newText = node.nodeValue.replace(/(\d)\.00(?!\d)/g, '$1');
            if (newText !== node.nodeValue) {
              node.nodeValue = newText;
            }
          }
        });
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', stripDecimalsFromCards);
      } else {
        stripDecimalsFromCards();
      }

      document.addEventListener('change', function (e) {
        if (e.target.matches('.variant-dropdown, .variant-radio')) {
          setTimeout(stripDecimalsFromCards, 30);
        }
      });

      document.addEventListener('cart:updated', stripDecimalsFromCards);
      document.addEventListener('cart:change', stripDecimalsFromCards);
    })();
  
